import React from 'react';
import { FadeIn } from './ui';
export const Hero = () => {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden" data-id="element-46">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-47">
        <div className="order-2 md:order-1 flex flex-col items-center md:items-start text-center md:text-left z-10" data-id="element-48">
          <FadeIn data-id="element-49">
            <p className="text-amber uppercase tracking-widest text-xs font-medium mb-6" data-id="element-50">
              A gentle reset for an overthinking mind
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-51">
            <h1 className="text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-6 text-balance" data-id="element-52">
              The 3AM <br data-id="element-53" />
              <span className="italic text-amber/90" data-id="element-54">Mind-Quiet</span> <br data-id="element-55" />
              Script
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-56">
            <p className="text-lg md:text-xl text-parchment-muted font-light leading-relaxed max-w-md mb-10" data-id="element-57">
              Force your brain out of the "panic loop" and reach deep sleep in
              under 11 minutes—without medication or willpower.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-58">
            <button className="bg-amber text-midnight font-medium px-8 py-4 rounded-md transition-all hover:bg-amber-hover hover:shadow-[0_0_20px_rgba(212,154,92,0.2)]" data-id="element-59">
              Get the Script — $6.99
            </button>
          </FadeIn>
        </div>

        <div className="order-1 md:order-2 relative z-10" data-id="element-60">
          <FadeIn delay={0.2} data-id="element-61">
            <div className="relative rounded-xl overflow-hidden shadow-2xl shadow-black/50 border border-white/5" data-id="element-62">
              <div className="absolute inset-0 bg-gradient-to-tr from-midnight/40 to-transparent mix-blend-overlay z-10 pointer-events-none" data-id="element-63"></div>
              <img src="https://cdn.magicpatterns.com/uploads/nVppyAbTsntQX3gcWaWf7C/ChatGPT_Image_May_15,_2026,_12_56_58_PM.png" alt="Woman reading The 3AM Mind-Quiet Script on a tablet in a dimly lit room" className="w-full h-auto object-cover" data-id="element-64" />
            </div>
          </FadeIn>
          {/* Decorative ambient glow behind image */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-amber/10 blur-[100px] rounded-full -z-10" data-id="element-65"></div>
        </div>
      </div>
    </section>;
};